import { Box } from 'shared/ui/Box';
import { Icon } from 'shared/ui/Icon';
import { StarWrapper } from 'shared/ui/StarsSelect/styled';
import { Flex } from 'shared/ui/StyledComponents';

type Props = {
  maxValue: number;
  onChange: (value: number) => void;
  value?: number;
  errorMessage?: string;
};

export const StarsSelect = ({ maxValue, onChange, value, errorMessage }: Props) => {
  const options = Array.from({ length: maxValue }, (_, i) => i + 1);

  return (
    <Box>
      <Flex gap={20}>
        {options.map((option, index) => (
          <StarWrapper key={index} onClick={() => onChange(option)} isSelected={!!value && index + 1 <= value}>
            <Icon name='star' />
          </StarWrapper>
        ))}
      </Flex>
      {errorMessage && (
        <Box className='error' mt={2} color='red'>
          {errorMessage}
        </Box>
      )}
    </Box>
  );
};
